import {
  DOCUMENT_ACTIONS,
  FILE_ACTIONS,
  PLANNING_ACTIONS,
  RESEARCH_ACTIONS,
} from './progressLabelData.js'
import { cleanString, isToolProgressEvent, normalized } from './progressLabelText.js'

export function friendlyProgressLabel(event) {
  if (!event || typeof event !== 'object') return 'Working'
  if (isToolProgressEvent(event)) return 'Used a tool'
  const keys = progressKeys(event)
  if (keys.some((key) => PLANNING_ACTIONS.has(key) || key.includes('scope.plan'))) return 'Planning'
  if (keys.some((key) => RESEARCH_ACTIONS.has(key))) return 'Researching'
  if (keys.some((key) => key === 'summarize')) return 'Reviewing sources'
  if (keys.some((key) => DOCUMENT_ACTIONS.has(key))) return 'Generating document'
  if (keys.some((key) => FILE_ACTIONS.has(key))) return 'Writing files'
  if (keys.some((key) => key === 'validate')) return 'Checking the result'
  if (event.type === 'run_started' || event.type === 'run_status') return 'Planning'
  return 'Working'
}

function progressKeys(event) {
  return [
    event.action,
    event.capability,
    event.eventType,
    event.label,
    event.traceText,
    event.summary,
    event.type,
  ]
    .flatMap((value) => splitProgressValue(value))
    .filter(Boolean)
}

function splitProgressValue(value) {
  const text = normalized(value)
  if (!text) return []
  return text.split(/[^a-z0-9_.-]+/).filter(Boolean)
}

export function dedupeFriendlyRows(values) {
  const seen = new Set()
  return values.filter((value) => {
    const text = cleanString(value)
    if (!text || seen.has(text)) return false
    seen.add(text)
    return true
  })
}
